const StudyStatusEnum = {
    WAITING: 0,
    TIMEOUT_HAS_NOT_CONFIRMED_REPORT: 1,
    COMPLETED: 2,
    HAS_NOT_CONFIRMED_REPORT: 3,
    STUDY_LOCKED: 4,
}

export default StudyStatusEnum